import * as ACTION from 'actions'

const initialState = {
  refund: {
    id: '',
    projectId: '',
    iosHandleUrl: '',
    androidHandleUrl: ''
  }
};

export function refund(state=initialState, action) {
    if(action == null) return  state;
    switch (action.type) {
        case ACTION.FETCH_REFUND:
            return {
              ...state,
              refund: action.refund
            }
        case ACTION.UPDATE_REFUND:
            return {
              ...state,
              refund: action.refund
            }
        default:
            return state
    }
}
